import type { FilterSet } from "lib/components/builders/search/FilterDrawer";

export enum MasterPlanFilter {
  STATUS = "status",
  PLAN_TYPE = "planType",
}

export enum MasterPlanStatusValue {
  ACTIVE = "active",
  ARCHIVED = "archived",
}

export enum MasterPlanTypeValue {
  MULTI_UNIT = "multiUnit",
  SINGLE_FAMILY = "singleFamily",
}

const statusOptions: { [key in MasterPlanStatusValue]: string } = {
  [MasterPlanStatusValue.ACTIVE]: "Active",
  [MasterPlanStatusValue.ARCHIVED]: "Archived",
};

const planTypeOptions: { [key in MasterPlanTypeValue]: string } = {
  [MasterPlanTypeValue.MULTI_UNIT]: "Multi-unit",
  [MasterPlanTypeValue.SINGLE_FAMILY]: "Single family",
};

/**
 * Filter types and their possible values for the Plan Library.
 * The plan-type set is omitted entirely when `configTownhomes` is off — `FilterSet.enabled`
 * is declared but never read by FilterDrawer, so omission is the only working gate.
 */
export function getFilterSets({ configTownhomes }: { configTownhomes: boolean }): FilterSet[] {
  const filterSets: FilterSet[] = [
    {
      name: MasterPlanFilter.STATUS,
      options: Object.entries(statusOptions).map(([value, label]) => ({ value, label })),
    },
  ];

  if (configTownhomes) {
    filterSets.push({
      name: MasterPlanFilter.PLAN_TYPE,
      options: Object.entries(planTypeOptions).map(([value, label]) => ({ value, label })),
    });
  }

  return filterSets;
}

export const filterLabels: [MasterPlanFilter, string][] = [
  [MasterPlanFilter.STATUS, "Status"],
  [MasterPlanFilter.PLAN_TYPE, "Plan Type"],
];
